import {Component, Input, OnInit} from '@angular/core';
import ArticleGroup, {OptionGroupForRender} from 'src/app/models/ArticleGroup';
import {OrderStatus} from 'src/app/models/OrderStatus';
import {groupOptionsByGroup} from '../manager-utils/manager-utils';

@Component({
	selector: 'app-order-item-articlegroup-draw',
	templateUrl: './order-item-articlegroup-draw.component.html',
	styleUrls: ['./order-item-articlegroup-draw.component.scss']
})
export class OrderItemArticlegroupDrawComponent implements OnInit {
	private _articleGroup: ArticleGroup;
	public optionGroups: OptionGroupForRender[] = [];

	// Grouping is computed once per input change instead of on every CD cycle
	@Input() set articleGroup(value: ArticleGroup) {
		this._articleGroup = value;
		this.optionGroups = groupOptionsByGroup(value?.groups);
	}
	get articleGroup(): ArticleGroup {
		return this._articleGroup;
	}
	@Input() orderStatus: OrderStatus | null;

	public orderStatusEnum = OrderStatus;
	constructor() {}

	ngOnInit() {}
}
